'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitRetractBid = exports.getUiRetractBid = exports.RETRACT_BID_SUCCESS = exports.RETRACT_BID_REQUEST = exports.RETRACT_BID_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getRetractBidItemId = getRetractBidItemId;

var _modal = require('../modules/modal');

var _user = require('../modules/user');

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('../modules/config');

var _analytics = require('../modules/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var RETRACT_BID_FAIL = exports.RETRACT_BID_FAIL = 'la/ui/retractBid/FAIL';
var RETRACT_BID_REQUEST = exports.RETRACT_BID_REQUEST = 'la/ui/retractBid/REQUEST';
var RETRACT_BID_SUCCESS = exports.RETRACT_BID_SUCCESS = 'la/ui/retractBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidRetracted: false,
    error: false,
    itemId: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                bidRetracted: false
            });
        case _modal.OPEN_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                itemId: action.payload.itemId
            });
        case RETRACT_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                bidRetracted: true,
                submitted: true,
                success: false
            });
        case RETRACT_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case RETRACT_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var retractBidSelector = function retractBidSelector(state) {
    return state.ui.retractBid;
};

var getUiRetractBid = exports.getUiRetractBid = (0, _reselect.createSelector)(retractBidSelector, function (retractBid) {
    return retractBid;
});

function getRetractBidItemId(state) {
    return state && state.ui && state.ui.retractBid && state.ui.retractBid.itemId ? state.ui.retractBid.itemId : null;
}

/* ACTION CREATORS */
var retractBidFail = function retractBidFail(error) {
    return {
        error: true,
        payload: error,
        type: RETRACT_BID_FAIL
    };
};

var retractBidRequest = function retractBidRequest(itemId, retractionReason, retractionExplanation) {
    return {
        payload: {
            itemId: itemId,
            retractionExplanation: retractionExplanation,
            retractionReason: retractionReason
        },
        type: RETRACT_BID_REQUEST
    };
};

var retractBidSuccess = function retractBidSuccess(itemId, analytics) {
    return {
        meta: {
            analytics: analytics.analytics,
            itemId: itemId
        },
        payload: itemId,
        type: RETRACT_BID_SUCCESS
    };
};

var submitRetractBid = exports.submitRetractBid = function submitRetractBid(itemId, retractionReason, retractionExplanation) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var userData = (0, _user.getUserData)(state);
        var bidderId = userData.bidderId;
        dispatch(retractBidRequest(itemId, retractionReason, retractionExplanation));
        return _api.Bid.postRetractBid({
            authToken: authToken,
            bidderId: bidderId,
            deployment: deployment,
            itemId: itemId,
            retractionExplanation: retractionExplanation,
            retractionReason: retractionReason
        }).then(function () {
            var analytics = (0, _analytics.getRetractedAbsenteeBidAnalytics)(state, itemId, retractionReason, retractionExplanation);
            dispatch(retractBidSuccess(itemId, analytics));
        }).catch(function (error) {
            dispatch(retractBidFail(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/retractBid.js
// module id = M0zy
// module chunks = 46